import "../vendor/jquery-ui/jquery-ui"
import Highcharts from  "../../vendor/highcharts/highcharts.js";
import $ from "jquery";

$.widget('customer.clothingHygieneStatistics', {
    options: {
    },
    SetAllValue: function (Input, Output) {
        if (Input !== undefined) {
            Input.forEach((point, i) => {

                if (point > 0) {

                    Output.push(point);

                }
                else
                    Output.push(null);
            })
        }

    },
    // Constructor
    _create: function () {
      
        let $linjeContainer = $(this.element).find(".chart-container.linje");
        let $stapelContainer = $(this.element).find(".chart-container.stapel");
        let linjeId = $linjeContainer.attr("id");
        let stapelId = $stapelContainer.attr("id");

        let monthList = $(this.element).find("[data-selector='monthList']");
        let weeks = monthList.attr("data-value").split(',');

        let dataField1Element = $(this.element).find("[data-selector='dataField1']");
        let dataField2Element = $(this.element).find("[data-selector='dataField2']");
        //let observationElement = $(this.element).find("[name=observation]");
        //let selfEsteemElement = $(this.element).find("[name=selfEsteem]");

        let dataField1Data = dataField1Element.attr("data-value") !== undefined ? dataField1Element.attr("data-value").split(',').map(Number) : undefined;
        let dataField2Data = dataField2Element.attr("data-value") !== undefined ? dataField2Element.attr("data-value").split(',').map(Number) : undefined;
        //let observationdata = observationElement.val() !== undefined ? observationElement.val().split(',').map(Number) : undefined;
        //let selfEsteemData = selfEsteemElement.val() !== undefined ? selfEsteemElement.val().split(',').map(Number) : undefined;

        let dataField1Name = dataField1Element.attr("data-name");
        let dataField2Name = dataField2Element.attr("data-name");
        //let observationName = observationElement.attr("data-name");
        //let selfEsteemName = selfEsteemElement.attr("data-name");

        var dataField1 = [];
        this.SetAllValue(dataField1Data, dataField1)
        dataField1Data = dataField1;

        var dataField2 = [];
        this.SetAllValue(dataField2Data, dataField2)
        dataField2Data = dataField2;

        //var observation = [];
        //setInterval(observationdata, observation)
        //methodData = observation;

        if (linjeId !== undefined) {
            let chart = Highcharts.chart(linjeId, {
                title: null,
                xAxis: {
                    title: {
                        text: 'Månad'
                    },
                    categories: weeks
                },
                yAxis: {
                    max: 100,
                    min: 0,
                    title: {
                        text: '%'
                    }
                },
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'top'
                },
                tooltip: {
                    headerformat: '<b>{series.name}</b><br>',
                    pointFormat: '<b>{series.name}:</b> {point.y} % <br/>'
                },
                series: [{
                    data: dataField1Data,
                    name: dataField1Name
                },
                {
                    name: dataField2Name,
                    data: dataField2Data,
                }
                ],

                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 1160
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'top'
                            }
                        }
                    }]
                }

            });

            chart.reflow();
        }
        else if (stapelId !== undefined) {
            let stapelChart = Highcharts.chart(stapelId, {
                chart: {
                    type: 'column'
                },
                title: null,
                xAxis: {
                    title: {
                        text: 'Månad'
                    },
                    categories: weeks,

                },
                subtitle: {
                    align: 'left',
                },
                accessibility: {
                    announceNewData: {
                        enabled: true
                    }
                },
                yAxis: {
                    max: 100,
                    min: 0,
                    title: {
                        text: '%'
                    }
                },
                tooltip: {
                    shared: true
                },
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'top',

                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        grouping: false,
                    },
                    column: {
                        stacking: 'normal'
                    }
                },

                series: [{
                    name: dataField1Name,
                    data: dataField1Data,


                }, {
                    name: dataField2Name,
                    data: dataField2Data,


                }
                ],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 1170
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'top'
                            }
                        }
                    }]
                }

            });

            stapelChart.reflow();
        }


    },
    _destroy: function () {
    },

});